import { Observable } from 'rxjs';

import { INotification, Notification } from 'domain/notification/notification';

export abstract class NotificationRepositoryPort {
	public abstract deleteNotification(id: string): void;

	public abstract observeNotifications(): Observable<INotification[]>;

	public abstract saveNotifications(notifications: Notification[]): void;

	public abstract observeNotification(
		notificationId: string
	): Observable<INotification>;

	public abstract deleteNotifications(ids: string[]): void;
}
